/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Not_AuthenticatedInputs */



/**
* | output |
* | --- |
* | "Not authenticated. Please log in again." |
*
* @param {Profile_Not_AuthenticatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_not_authenticated = /** @type {((inputs?: Profile_Not_AuthenticatedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Not_AuthenticatedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Non authentifié. Veuillez vous reconnecter.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No autenticado. Por favor, inicie sesión de nuevo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não autenticado. Por favor, faça login novamente.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non autenticato. Effettua nuovamente l'accesso.")
	return /** @type {LocalizedString} */ ("Not authenticated. Please log in again.")
});